import { HighlightArea } from "@components/HighlightTextArea/HighlightTextArea"

export const getTextWithMarkedAreas = (text: string, areas: HighlightArea[]): string => {
  let highlightedText = ""
  let lastIndex = 0

  for (const area of areas) {
    // text before the highlight area
    highlightedText += text.slice(lastIndex, area.startIndex)
    // highlighted text
    highlightedText += `<mark>${text.slice(area.startIndex, area.endIndex)}</mark>`
    // lastIndex to the end of the current highlight
    lastIndex = area.endIndex
  }

  // remaining text after the last highlight area
  highlightedText += text.slice(lastIndex)

  return highlightedText
}
